import citys from "./citys";

class Constants {
	// 城市列表
	citys = citys;

	// 处理状态
	salepacketStatus = [
		{
			label: "待提交",
			value: "1",
		},
		{
			label: "待审核",
			value: "2",
		},
		{
			label: "审核通过",
			value: "3",
		},
		{
			label: "审核不通过",
			value: "4",
		},
	];
	// 保单状态 1-生效中 2-已退保
	salepacketPolicyStatus = [
		{
			label: "生效中",
			value: "1",
		},
		{
			label: "已退保",
			value: "2",
		},
	];
	// 到账状态 状态 1.待付款 2.付款中 3.已付款 4.付款失败
	salepacketPayStatus = [
		{
			label: "待付款",
			value: "1",
		},
		{
			label: "付款中",
			value: "2",
		},
		{
			label: "已付款",
			value: "3",
		},
		{
			label: "付款失败",
			value: "4",
		},
	];
	// 配置单状态 1-待审核 2-已生效 3-已作废
	salepacketConfigStatus = [
		{
			label: "待审核",
			value: "1",
		},
		{
			label: "已生效",
			value: "2",
		},
		{
			label: "已作废",
			value: "3",
		},
	];

	// 订单资料审核状态
	orderExamineStatus = [
		{
			label: "未审核",
			value: 1,
			color: "#409EFF",
		},
		{
			label: "审核通过",
			value: 2,
			color: "#67C23A",
		},
		{
			label: "审核不通过",
			value: 3,
			color: "#F56C6C",
		},
	];

	/**
	 * 复核结果：1=待复核，2=复核通过，3=复核不通过
	 */
	recheckStatus = [
		{
			label: "待复核",
			value: 1,
			color: "#409EFF",
		},
		{
			label: "复核通过",
			value: 2,
			color: "#67C23A",
		},
		{
			label: "复核不通过",
			value: 3,
			color: "#F56C6C",
		},
	];

	/**
	 * 核保单状态 1-待审核，2-审核通过，3-审核不通过
	 */
	checkStatus = [
		{
			label: "待审核",
			value: 1,
			color: "#409EFF",
		},
		{
			label: "已通过",
			value: 2,
			color: "#67C23A",
		},
		{
			label: "未通过",
			value: 3,
			color: "#F56C6C",
		},
		{
			label: "待提交",
			value: 4,
			color: "#409EFF",
		},
	];

	/**
	 * 识别状态：1=待识别，2=识别中，3=识别通过，4=识别不通过
	 */
	discernStatus = [
		{
			label: "待识别",
			value: 1,
			color: "#909399",
		},
		{
			label: "识别中",
			value: 2,
			color: "#409EFF",
		},
		{
			label: "识别通过",
			value: 3,
			color: "#67C23A",
		},
		{
			label: "识别不通过",
			value: 4,
			color: "#F56C6C",
		},
	];

	/**
	 * 识别结果：1=合格，2=不合格
	 */
	recognitionStatus = [
		{
			label: "合格",
			value: 1,
			color: "#67C23A",
		},
		{
			label: "不合格",
			value: 2,
			color: "#F56C6C",
		},
	];

	/**
	 * 支付状态：1=待支付，2=已支付
	 */
	payStatus = [
		{
			label: "已支付",
			value: 2,
			color: "#67C23A",
		},
		{
			label: "待支付",
			value: 1,
			color: "#409EFF",
		},
	];

	// 保障类型 1.全保焕新 2.碎屏 3.延保（新增）
	safeguardType = [
		{
			label: "全保焕新",
			value: 1,
		},
		{
			label: "碎屏",
			value: 2,
		},
		{
			label: "延保",
			value: 3,
		},
	];

	// 保障时长类型 1.月包 2.季包 3.半年包 4.年包（新增
	safeguardDurationType = [
		{
			label: "月包",
			value: 1,
		},
		{
			label: "季包",
			value: 2,
		},
		{
			label: "半年包",
			value: 3,
		},
		{
			label: "年包",
			value: 4,
		},
	];

	/**
	 * 是否
	 */
	isOr = [
		{
			label: "是",
			value: 1,
			color: "#67C23A",
		},
		{
			label: "否",
			value: 0,
			color: "#409EFF",
		},
	];

	/**
	 * 是否 - 短信
	 */
	isOrMsg = [
		{
			label: "发送",
			value: 1,
			color: "#67C23A",
		},
		{
			label: "不发送",
			value: 0,
			color: "#409EFF",
		},
	];

	/**
	 * 分佣订单导入 - 状态
	 */
	importStatus = [
		{
			label: "导入中",
			value: 1,
		},
		{
			label: "导入成功",
			value: 2,
		},
		{
			label: "导入部分成功",
			value: 3,
		},
		{
			label: "导入失败",
			value: 4,
		},
	];

	/**
	 * 维修单审核状态 1-待审核，2-审核通过，3-审核不通过
	 */
	auditstatus = [
		{
			label: "待审核",
			value: "1",
			color: "#409EFF",
		},
		{
			label: "已通过",
			value: "2",
			color: "#67C23A",
		},
		{
			label: "审核不通过",
			value: "3",
			color: "#F56C6C",
		},
	];

	/**
	 * 维修单维修状态 1-待维修，2-维修中，3-确认维修维修成功
	 */
	repairstatus = [
		{
			label: "待维修",
			value: "1",
			color: "#409EFF",
		},
		{
			label: "维修中",
			value: "2",
			color: "#409EFF",
		},
		{
			label: "确认维修维修成功",
			value: "3",
			color: "#67C23A",
		},
		{
			label: "确认维修维修失败",
			value: "4",
			color: "#F56C6C",
		},
	];
	/**
	 * 维修未成功原因
	 */
	reasonList = [
		{ label: "超限额", value: "1" },
		{ label: "市场缺件", value: "2" },
		{ label: "用户原因取消服务", value: "3" },
		{ label: "其他", value: "4" },
	];
	/**
	 * 是否
	 */
	backIsOr = [
		{
			label: "已回传",
			value: "1",
			color: "#67C23A",
		},
		{
			label: "未回传",
			value: "0",
			color: "#409EFF",
		},
	];

	// 保障类型 1.全保焕新 2.碎屏 3.延保（新增）
	cardTypeOptions = [
		{
			label: "身份证",
			value: "身份证",
		},
		{
			label: "护照",
			value: "护照",
		},
		{
			label: "港澳通行证",
			value: "港澳通行证",
		},
		{
			label: "台胞证",
			value: "台胞证",
		},
	];
	// 保障类型 1.全保焕新 2.碎屏 3.延保（新增）
	policyStatus = [
		{
			label: "待提交",
			value: "待提交",
		},
		{
			label: "在保",
			value: "在保",
		},
		{
			label: "保单过期",
			value: "保单过期",
		},
		{
			label: "保单中止",
			value: "保单中止",
		},
	];

	/**
	 * 状态转文字
	 * @param {*} name 类型名
	 * @param {*} type 类型值
	 * @returns label
	 */
	getLabel = (name, type) => {
		let label = "";
		for (let obj of this[name]) {
			if (obj.value == type) {
				label = obj.label;
				break;
			}
		}
		return label;
	};

	/**
	 * 状态取颜色
	 * @param {*} name 类型名
	 * @param {*} type 类型值
	 * @returns color
	 */
	getColor = (name, type) => {
		let color = "";
		for (let obj of this[name]) {
			if (obj.value == type) {
				color = obj.color;
				break;
			}
		}
		return color;
	};
}

export default new Constants();
